import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationBadgeService {
  private originalFavicon: HTMLImageElement = new Image();
  private linkElement: HTMLLinkElement | null;

  constructor() {
    this.linkElement = document.querySelector("link[rel~='icon']");
    if (this.linkElement) {
      this.originalFavicon.src = this.linkElement.href;
    }
  }

  updateFavicon(count: number): void {
    if (!this.linkElement || !this.originalFavicon.complete) return;

    const canvas = document.createElement('canvas');
    const size = 64;
    canvas.width = size;
    canvas.height = size;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    ctx.drawImage(this.originalFavicon, 0, 0, size, size);

    if (count > 0) {
      const circleRadius = 24;
      const circleX = size - 24;
      const circleY = size - 24;

      ctx.fillStyle = 'green'; //'#00a3e2';
      ctx.beginPath();
      ctx.arc(circleX, circleY, circleRadius, 0, Math.PI * 2);
      ctx.fill();

      ctx.fillStyle = 'white';
      ctx.font = 'bold 36px Arial';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

      ctx.fillText(count.toString(), circleX, circleY);
    }
    this.linkElement.href = canvas.toDataURL('image/png');
  }

  resetFavicon(): void {
    if (this.linkElement) {
      this.linkElement.href = this.originalFavicon.src;
    }
  }
}
